import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function EmptyState({ icon: Icon, title, description, actionLabel, actionTo, onAction, testid }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={testid || "empty-state"}
      className="flex flex-col items-center justify-center text-center py-14 px-6 rounded-2xl border border-dashed border-slate-200 bg-white"
    >
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-accent flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-primary" />
        </div>
      )}
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-sm">{description}</p>}
      {actionLabel && (
        <Button
          data-testid="empty-state-action"
          className="mt-5 rounded-full"
          onClick={() => (onAction ? onAction() : navigate(actionTo))}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
